import { useLocation } from '@pankod/refine-react-router-v6';
import { useMemo } from 'react';

export const useQuery = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};
